
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HeaderToolbar extends Vue {
    logoZurich: string = require('../../../../assets/logo_zurich.png');
}
